import React, {FC} from "react";
import {NavLink} from "react-router-dom";
import style from "./FooterLogo.module.css";

export const FooterLogo: FC = () => {
    return <div className={style.footerLogo}>
        <NavLink to="/">
            <svg width="42" height="38" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.3">
                    <path fillRule="evenodd" clipRule="evenodd" d="M13.7227 37.9996H27.4448V0H13.7227V37.9996Z"
                          fill="white"></path>
                    <path fillRule="evenodd" clipRule="evenodd" d="M41.1684 11.3336L28.895 0H41.1684V11.3336Z"
                          fill="white"></path>
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M7.62939e-06 11.3511L12.2912 0.000976562H7.62939e-06V11.3511Z" fill="white"></path>
                </g>
            </svg>
        </NavLink>
    </div>
};
